<script setup>
import WorkTimeEntryGrid from '@/components/garage/WorkTimeEntryGrid.vue'
</script>
<template>
  <work-time-entry-grid />
</template>
